import Lottie from 'lottie-react'
import { motion, AnimatePresence } from 'framer-motion'

// You'll need to import your Lottie JSON files
import successAnimation from './assets/successTick.json'

type CelebrationType = 'success' | null

interface LottieCelebrationProps {
  type: CelebrationType
  message?: React.ReactNode
  onComplete?: () => void
}

export function LottieCelebration({
  type,
  message,
  onComplete,
}: LottieCelebrationProps) {
  const animations = {
    success: successAnimation,
  }

  return (
    <AnimatePresence onExitComplete={onComplete}>
      {type && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 pointer-events-none flex flex-col items-center justify-center"
        >
          <div className="w-64 h-64">
            <Lottie
              animationData={animations[type]}
              loop={false}
              onComplete={onComplete}
              autoplay
            />
          </div>
          {message && <div className="mt-4">{message}</div>}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
